import CommonDatePicker from "@lhd/components/CommonDatePicker";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import { parseDatePickerInput } from "@lhd/utility";
import moment, { Moment } from "moment";
import { KeyboardEvent } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const getDateValue = (value: any): Moment | undefined => {
  if (value === null || value === undefined || value === "") return undefined;

  const date =
    typeof value === "string"
      ? moment(
          value.trim(),
          [
            DATE_TIME_FORMAT.DATE_QUERY,
            DATE_TIME_FORMAT.DATE_DEFAULT,
            DATE_TIME_FORMAT.DATE_JP,
            DATE_TIME_FORMAT.DATE_JP_MD,
            moment.ISO_8601,
          ],
          true,
        )
      : moment(value);

  return date.isValid() ? date : undefined;
};

const DateEditCell = (props: ICommonFieldProps) => {
  const {
    defaultValue,
    onChange,
    colDef,
    getCellValue,
    disabledDate: externalDisabledDate,
    isDisabledDateLoading,
    onOpenChange,
  } = props;
  const disabledDate = (current: Moment) => {
    const { lessThanField, greaterThanField } = colDef;
    const upperBound = lessThanField
      ? getDateValue(getCellValue?.(lessThanField))
      : undefined;
    const lowerBound = greaterThanField
      ? getDateValue(getCellValue?.(greaterThanField))
      : undefined;

    const isDisabledByRelatedField =
      Boolean(upperBound && current.isAfter(upperBound, "day")) ||
      Boolean(lowerBound && current.isBefore(lowerBound, "day"));

    return (
      Boolean(isDisabledDateLoading) ||
      isDisabledByRelatedField ||
      Boolean(externalDisabledDate?.(current))
    );
  };

  const commit = (raw: string | null) => {
    const text = (raw ?? "").trim();
    if (!text) {
      onChange?.("");
      return;
    }
    const parsed = parseDatePickerInput(text) ?? getDateValue(text);
    if (!parsed || disabledDate(parsed)) return;
    onChange?.(parsed.format(DATE_TIME_FORMAT.DATE_QUERY));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    event.stopPropagation();
    const input = event.currentTarget.querySelector("input");
    commit(input?.value ?? "");
  };

  return (
    <CommonDatePicker
      className="input-field"
      wrapperStyle={{ width: "100%", height: "100%" }}
      saveFormat="api"
      displayFormat={DATE_TIME_FORMAT.DATE_JP_MD}
      defaultValue={defaultValue || null}
      allowClear
      disabledDate={disabledDate}
      onOpenChange={onOpenChange}
      onChange={(saved) => commit(saved)}
      onKeyDown={handleKeyDown}
    />
  );
};

export default DateEditCell;
